import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const initialValues = null;
const usePathwayParamsStore = create()(immer(() => initialValues));
const { setState: set } = usePathwayParamsStore;

export const pathwayParamsActions = {
  init: params => set({ params }),
  clear: () => set(initialValues, true),
  updateParams: async params => set({ params }),
};

export const usePathwayParams = () => usePathwayParamsStore(store => store?.params);

export default usePathwayParamsStore;
